import { PartnerSignupData } from '../../PartnerSignup';
import Form from '../../../../../common/_custom/Form/Form';
import {
    COUNTRY_CODE,
    EMAIL,
    EMAIL_ERROR_MSG,
    FULL_NAME,
    FULL_NAME_ERROR_MSG,
    ORG_NAME,
    PASSWORD,
    PASSWORD_ERROR_MSG,
    PHONE,
    PHONE_ERROR_MSG,
} from '../../../../../utils/constants/companyLogin';
import { Button, Input } from '../../../../../common/_custom';
import { useState } from 'react';
import styles from '../../PartnerSignup.module.scss';
import CountryCodesDropdown from '../../../../Company/CompanyLogin/CountryCodesDropdown/CountryCodesDropdown';
import { INVESTOR_ROUTES } from '../../../../../utils/constants/routesConst';
import { useNavigate } from 'react-router-dom';
import { partnerFormValidations } from '../../../../../utils/constants/formValidations';
import { useAppSelector } from '../../../../../app/hooks';
import { greenCheck } from '../../../../../assets/hostedassets'; // green check icon
import PasswordStrengthChecker from '../../../../../common/PasswordChecker/PasswordStrengthChecker';
type GettingStartedFormProps = {
    formData: PartnerSignupData;
    setFormData: Function;
    handleFormChange: Function;
    handleSubmitClick: Function;
    children?: React.ReactNode;
    isFocused: boolean;
    setIsFocused: (val: boolean) => void;

    disableSubmit: boolean; // disable button until all checks fullfilled  // disable flag
    // boolean
};

const GettingStartedForm = (props: GettingStartedFormProps) => {
    const navigate = useNavigate();
    const { formData, handleFormChange, handleSubmitClick, disableSubmit } = props;
    const isSigupLoading = useAppSelector((state) => state.user.creatingAccount);
    const [errors, setErrors] = useState({
        [FULL_NAME]: false,
        [EMAIL]: false,
        [PHONE]: false,
        [PASSWORD]: false,
    });

    const [isFocused, setIsFocused] = useState(false); // for focus and bluring the rule

    const changeValue = (val, key) => {
        setErrors((errors) => ({
            ...errors,
            [key]: false,
        }));
        handleFormChange(val, key);
    };

    const onSubmit = () => {
        setErrors({
            [FULL_NAME]: !partnerFormValidations.isFullNameValid(formData[FULL_NAME]),
            [EMAIL]: !partnerFormValidations.isEmailValid(formData[EMAIL]),
            [PHONE]: !partnerFormValidations.isPhoneValid(formData[PHONE], formData[COUNTRY_CODE]),
            [PASSWORD]: !partnerFormValidations.isPasswordValid(formData[PASSWORD]),
        });

        if (partnerFormValidations.allValid(formData)) handleSubmitClick();
    };

    return (
        <>
            <h2>Getting Started</h2>
            <Form>
                <Input
                    placeholder="Full Name"
                    value={formData[FULL_NAME]}
                    onChange={(val: string) => changeValue(val, FULL_NAME)}
                    errorMessage={FULL_NAME_ERROR_MSG}
                    isValid={!errors[FULL_NAME]}
                    allowAllCharacters={true}
                />
                <Input
                    placeholder="Email"
                    value={formData[EMAIL]}
                    onChange={(val: string) => changeValue(val.trim(), EMAIL)}
                    errorMessage={EMAIL_ERROR_MSG}
                    isValid={!errors[EMAIL]}
                    allowAllCharacters={true}
                />
                <div className={styles.Row}>
                    <CountryCodesDropdown
                        //@ts-ignore
                        setCountryCode={(val) => changeValue(val, COUNTRY_CODE)}
                    />
                    <Input
                        type="number"
                        placeholder="Phone Number"
                        value={formData[PHONE]}
                        onChange={(val: string) => changeValue(val, PHONE)}
                        errorMessage={PHONE_ERROR_MSG}
                        isValid={!errors[PHONE]}
                        style={{ marginTop: '0', width: '100%' }}
                    />
                </div>
                <Input
                    value={formData[ORG_NAME]}
                    onChange={(val) => handleFormChange(val, ORG_NAME)}
                    placeholder="Organisation Name (Optional)"
                    style={{ marginTop: '30px' }}
                    allowAllCharacters={true}
                />
                <Input
                    placeholder="Password"
                    type="password"
                    value={formData[PASSWORD]}
                    onChange={(val: string) => changeValue(val, PASSWORD)}
                    errorMessage={PASSWORD_ERROR_MSG}
                    isValid={!errors[PASSWORD]}
                    allowAllCharacters={true}
                    onFocusProp={() => props.setIsFocused(true)}
                    onBlurProp={() => props.setIsFocused(false)}
                />
                {props.children}

                <Button
                    variant={'primary'}
                    style={{ width: '100%', marginTop: '12px' }}
                    text="Create Account"
                    loadingText="Please Wait"
                    loading={isSigupLoading}
                    onClick={onSubmit}
                    disabled={disableSubmit} //  disable until password meets all checks
                />
                <div className={styles.Separator} />
                <div style={{ textAlign: 'center', fontSize: '14px' }} className={styles.Signup}>
                    Already have an account?&nbsp;
                    <button className={styles.Login} onClick={() => navigate(INVESTOR_ROUTES.LOGIN)}>
                        Login
                    </button>
                </div>
            </Form>
        </>
    );
};

export default GettingStartedForm;
